import { Card } from "react-bootstrap";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadingSpinner } from "../../../../_components/Abstractions/LoadingSpinner";
import s from "./style.module.css";
import { FilterDropdown } from "../../../../_components/Abstractions/FilterDropdown";
import { FilterForm } from "../../../../_components/Forms/FilterForm";
import { AddressContractorFilterSelect } from "../../../../_components/Contractors/ContractorFilterSelect";
import { ContractorRatePlansView } from "./ContractorRatePlansView";
import { ratePlansActions } from "../../../../_store/ratePlan.slice";

export function ContractorRatePlansDetails() {
  const [currentFilters, setCurrentFilters] = useState({});
  const { contractorData: { id, name, intermediaries, contractorTypes, addresses } } = useSelector(x => x.contractors);
  const { ratePlans } = useSelector(x => x.ratePlans);
  useGetContractorRatePlansDetails({ id, currentFilters });
  const isLoading = !ratePlans || ratePlans?.loading;
  const intermediariesDictionary = intermediaries ? Object.fromEntries(intermediaries?.map((x) => [x.intermediaryId, x.name])) : [];

  const filters = <div className="d-flex gap-2">
    <AddressContractorFilterSelect name="addressId" addresses={addresses} saveWholeObject={false}/>
    <FilterDropdown labelClassName="small" label="Pośrednik" items={intermediariesDictionary} name="intermediaryId"/>
  </div>;

  if (!ratePlans) {
    return;
  }

  return (
    <Card className={s.sectionCard}>
      <Card.Header as="h4">Cenniki</Card.Header>
      <Card.Body className="upper">
        <Card.Header as="h5">
          <FilterForm setCurrentFilters={setCurrentFilters} currentFilters={currentFilters} onSubmit={() => {}} formControls={filters}/>
        </Card.Header>
        <LoadingSpinner isLoading={ratePlans?.loading} as="div"/>
        <ContractorRatePlansView
          isLoading={isLoading}
          ratePlans={ratePlans}
          contractorId={id}
          contractorName={name}
          contractorTypes={contractorTypes}
          addresses={addresses}
          intermediaries={intermediaries}
          isRelatedView={false}/>
      </Card.Body>
    </Card>
  );
}

export function useGetContractorRatePlansDetails({ id, currentFilters }) {
  const dispatch = useDispatch();

  const getContractorRatePlans = useCallback(async({ id, currentFilters, token }) => {
    const payload = {
      addressId: currentFilters.addressId !== "" ? currentFilters.addressId : null,
      intermediaryId: currentFilters.intermediaryId !== "" ? currentFilters.intermediaryId : null
    };
    dispatch(ratePlansActions.getRatePlans({ id, payload, token }));
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    const token = abortController.signal;
    if (!id) {
      return;
    }

    getContractorRatePlans({ id, currentFilters, token });

    return () => {
      // if(process.env.REACT_APP_ENVIROMENT === "Development") { return; }
      abortController.abort();
    };
  }, [id, currentFilters, getContractorRatePlans]);

  return { getContractorRatePlans };
}